import React from "react";
import { RelatorioReceitasItem } from "core/features/relatorios/typings/index";
import { View, Text } from "@react-pdf/renderer";
import { commonRelatorioPdfStyles } from "components/Relatorio/styles";
import { PDFTable } from "ui/components/PDF";
import useRelatorioReceitasPdfColumns from "./hooks/useRelatorioReceitasPdfColumns";
import TotalRow from "../TotalRow";
import { RelatorioReceitasFields } from "core/features/relatorios/typings";

interface PDFRelatorioReceitasItemTableProps {
  item: RelatorioReceitasItem;
  renderUnidade?: boolean;
  renderProprietario?: boolean;
  fields?: RelatorioReceitasFields[];
}

function ItemTable({
  item,
  renderProprietario,
  renderUnidade,
  fields,
}: PDFRelatorioReceitasItemTableProps) {
  const renderColumns = useRelatorioReceitasPdfColumns(fields);

  return (
    <View>
      <View style={commonRelatorioPdfStyles.itemTableTitleRow}>
        <Text style={commonRelatorioPdfStyles.itemTableTitle}>
          {renderUnidade ? item.unidade : ""}
          {renderUnidade && renderProprietario && item.unidadeId ? " - " : ""}
          {renderProprietario ? item.proprietario : ""}
        </Text>
      </View>
      <PDFTable
        data={item.contas}
        columns={renderColumns}
        tableHeaderVariant="rowLike"
      />
      <View style={commonRelatorioPdfStyles.itemTableSummary}>
        <TotalRow title="Total" valorTotal={item.valorTotal} />
      </View>
    </View>
  );
}

export default ItemTable;
